import script from "./VeBalRedirectModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VeBalRedirectModal.vue?vue&type=script&lang=ts&setup=true"

import "./VeBalRedirectModal.vue?vue&type=style&index=0&id=5f31462a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f31462a"]])

export default __exports__